import React, { Component } from 'react';
import { Badge } from '@dev-go4ellis/go4-design-system';
import './FAQ.scss';

const FAQS = [
  { q: 'How is the 17.5% calculated?', a: "It is a flat percentage of the trainer's pay (hours × rate × trainers). There are no other fees, markups, or add-ons." },
  { q: 'Do I pay anything to post a job?', a: 'No. Posting is completely free. You are only charged after a trainer actually works the shift.' },
  { q: 'Do I have to sign a contract?', a: 'No contracts, no subscriptions, no minimums. Use Go4 for one event or a full season — same pricing either way.' },
  { q: 'Who sets the hourly rate?', a: 'You do. Go4 never sets or marks up the rate. We show you what athletic trainers in your area have historically been paid so you can price competitively.' },
  { q: 'What if a trainer cancels?', a: 'You are not charged for shifts that were not worked. If a trainer cancels, we help you fill it — same fee structure.' },
  { q: 'Is insurance really included?', a: 'Yes. General liability insurance covers every shift booked through Go4 at no additional cost.' },
];

class FAQ extends Component {
  state = { openIndex: 0 };

  toggle = (i) => () => {
    this.setState((prev) => ({ openIndex: prev.openIndex === i ? -1 : i }));
  };

  render() {
    return (
      <section className="pl-faq">
        <div className="pl-faq__inner">
          <div className="pl-faq__badge">
            <Badge variant="soft" color="info" size="sm">PRICING QUESTIONS</Badge>
          </div>

          <h2 className="pl-faq__title">Frequently asked</h2>

          <div className="pl-faq__list">
            {FAQS.map((f, i) => {
              const isOpen = this.state.openIndex === i;
              return (
                <div key={f.q} className={`pl-faq__item ${isOpen ? 'is-open' : ''}`}>
                  <button
                    type="button"
                    className="pl-faq__q"
                    onClick={this.toggle(i)}
                    aria-expanded={isOpen}
                  >
                    <span>{f.q}</span>
                    <span className="pl-faq__toggle">{isOpen ? '−' : '+'}</span>
                  </button>
                  {isOpen && <div className="pl-faq__a">{f.a}</div>}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  }
}

export default FAQ;
